import React from "react";
import { Icon } from "@iconify/react";
import "bootstrap/dist/css/bootstrap.min.css";

const DocumentSuccess = () => {
    return (
        <div
            className="container-fluid"
            style={{
                minHeight: "100vh",
                background: "#F4F9FD",
            }}
        >
            <div className="row justify-content-center align-items-center min-vh-100 px-3">

                <div className="col-12 col-sm-10 col-md-8 col-lg-5">

                    <div
                        className="bg-white shadow-sm position-relative overflow-hidden"
                        style={{
                            borderRadius: "24px",
                            padding: "50px 35px",
                            border: "1px solid #E8EEF5",
                        }}
                    >

                        {/* Top Circle Background */}
                        <div
                            style={{
                                position: "absolute",
                                top: "-80px",
                                right: "-80px",
                                width: "180px",
                                height: "180px",
                                borderRadius: "50%",
                                background: "#E6F7FF",
                            }}
                        ></div>

                        {/* Success Icon */}
                        <div className="text-center position-relative">

                            <div
                                className="mx-auto d-flex align-items-center justify-content-center"
                                style={{
                                    width: "95px",
                                    height: "95px",
                                    borderRadius: "50%",
                                    background: "#E9FFF1",
                                    border: "6px solid #D4F8E1",
                                }}
                            >
                                <Icon
                                    icon="solar:check-circle-bold"
                                    width="52"
                                    color="#22C55E"
                                />
                            </div>

                            {/* Heading */}
                            <h2
                                className="fw-bold mt-4 mb-2"
                                style={{
                                    color: "#111827",
                                    fontSize: "32px",
                                }}
                            >
                                Thank You!
                            </h2>

                            {/* Description */}
                            <p
                                className="mb-4"
                                style={{
                                    color: "#6B7280",
                                    fontSize: "15px",
                                    lineHeight: "28px",
                                }}
                            >
                                Your documents have been uploaded successfully.
                                <br />
                                Our team is reviewing your submission.
                            </p>
                        </div>

                        {/* Status Box */}
                        <div
                            className="d-flex align-items-center justify-content-between flex-wrap gap-3"
                            style={{
                                background: "#F9FBFC",
                                border: "1px solid #E5E7EB",
                                borderRadius: "16px",
                                padding: "18px 20px",
                            }}
                        >

                            <div>
                                <p
                                    className="mb-1"
                                    style={{
                                        fontSize: "13px",
                                        color: "#9CA3AF",
                                        fontWeight: "500",
                                    }}
                                >
                                    Verification Status
                                </p>

                                <h6
                                    className="mb-0 fw-semibold"
                                    style={{
                                        color: "#111827",
                                    }}
                                >
                                    Under Review
                                </h6>
                            </div>

                            <div
                                className="d-flex align-items-center gap-2 px-3 py-2"
                                style={{
                                    background: "#FEF3C7",
                                    borderRadius: "50px",
                                }}
                            >
                                <div
                                    style={{
                                        width: "8px",
                                        height: "8px",
                                        borderRadius: "50%",
                                        background: "#F59E0B",
                                    }}
                                ></div>

                                <span
                                    style={{
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        color: "#92400E",
                                    }}
                                >
                                    Pending
                                </span>
                            </div>
                        </div>

                        {/* Bottom Note */}
                        <div className="text-center mt-4">
                            <p
                                className="mb-0"
                                style={{
                                    color: "#9CA3AF",
                                    fontSize: "13px",
                                }}
                            >
                                You will receive further updates shortly.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default DocumentSuccess;